export default __webpack_public_path__ + "static/media/schwarzenegger.5673e05e.png";